<template>
  <v-flex xs12 class="align-self-stretch pb-5" fill-height>
    <transition name="slide-x-transition" mode="out-in" appear>
      <tud-my-addresses v-if="tab === 1"></tud-my-addresses>
      <tud-user-map-mine v-if="tab === 2"></tud-user-map-mine>
      <tud-user-map-all v-if="tab === 3"></tud-user-map-all>
      <tud-all-addresses v-if="tab === 4"></tud-all-addresses>
    </transition>

    <v-bottom-nav shift value="true" class="primary">
      <v-btn :value="tab === 1" @click.native="tab = 1" class="white--text">
        <span>Adresele mele</span>
        <v-icon>person_pin_circle</v-icon>
      </v-btn>
      <v-btn :value="tab === 2" @click.native="tab = 2" class="white--text">
        <span>Adr. mele</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn :value="tab === 3" @click.native="tab = 3" class="white--text">
        <span>Toate adr</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn :value="tab === 4" @click.native="tab = 4" class="white--text">
        <span>Toate adresele</span>
        <v-icon>place</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-flex>
</template>

<script>
  export default {
    components: {
      'tud-my-addresses': () => import('@/components/MyAddresses.vue'),
      'tud-user-map-mine': () => import('@/components/UserMapMine.vue'),
      'tud-user-map-all': () => import('@/components/UserMapAll.vue'),
      'tud-all-addresses': () => import('@/components/AllAddresses.vue')
    },
    data () {
      return {
        tab: 1
      }
    },
    computed: {
      light () {
        return this.$store.getters.appLight
      }
    }
  }
</script>

<style lang="stylus">
  .bottom-nav {
    left: 0;
    .btn {
      max-width: calc(100% / 3);
      .btn__content {
        width: 100%;
        padding: 0;

        span {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Index.vue?5eceffad